export function truncatedText(text, num) {
  return text.length > num ? `${text.substring(0, num)}...` : text;
}

export function noRepeatText(text) {
  const textSplit = text.split(',');
  const textFinal = [...new Set(textSplit)].join(', ');
  return textFinal;
}

export function formatearEspecialidad(text) {
  let match = text.match(/\d+ - (.+)$/);
  if (match) {
    let especialidad = match[1];

    if (especialidad.includes('.')) {
      especialidad = especialidad.slice(0, -1);
    }

    return especialidad;
  } else {
    return text;
  }
}

export function formattedNumPrestador(codPrestador) {
  if (!codPrestador) return null;
  const codPrestadorFormatted = codPrestador.split('-');
  const codPrestadorFinal = codPrestadorFormatted[1].padStart(6, '0');
  const numeroPrestador = codPrestadorFormatted[0] + '01' + codPrestadorFinal;
  return numeroPrestador;
}

// Coloca mayúscula en la primer letra de todas las palabras 
export function toCamelCaseAllWords(string) {
  return string?.split(' ').map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(' ');
}

// Coloca mayúscula solo en la primer letra de la primer palabra
export function toCamelCaseFirstWord(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

// Elimina el guión de los números de teléfono
export function deleteDashPhoneNumber(phoneNumber) {
  return phoneNumber.replace(/-/g, '');
}
